import axios from "axios";
import {
  FETCH_ENCARGOS_REQUEST,
  FETCH_ENCARGOS_SUCCESS,
  FETCH_ENCARGOS_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionEncargosGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ENCARGOS_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/encargos", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_ENCARGOS_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar encargos";
    dispatch({ type: FETCH_ENCARGOS_FAILURE, payload: { error: msg } });
  }
};

export const apiEncargosInstance = api;
export { authHeader as authHeaderEncargos };
